export default __webpack_public_path__ + "static/media/avatar2.312c2aba.svg";